import { Modal } from "../../../UI/Layout";
import { FormDepartmentCode } from "../../../../containers/Order/FormDepartmentCode";
import { Button } from "../../../UI/Controls/Button";

interface IProps {
  visible: boolean;
  handleOk: any;
  handleCancel: any;
  disabled: boolean;
}

export const DepartmentCodeModal = ({
  visible,
  handleOk,
  handleCancel,
  disabled,
}: IProps): JSX.Element => (
  <Modal
    title="Department Code"
    open={visible}
    onOk={handleOk}
    okButtonProps={{ disabled }}
    onCancel={handleCancel}
    footer={[
      <Button key="back" onClick={handleCancel}>
        Cancel
      </Button>,
      <Button
        disabled={disabled}
        key="submit"
        type="primary"
        onClick={handleOk}
      >
        <span>&nbsp;Submit</span>
      </Button>,
    ]}
  >
    <FormDepartmentCode required={["departmentCode"]} />
  </Modal>
);
